import { createFileRoute, redirect } from "@tanstack/react-router";
import { TransferOrderGeneratePickingTaskPage } from "@/features/transfer-order/pages/TransferOrderGeneratePickingTaskPage";

export const Route = createFileRoute("/admin/transfer-order/$id/create")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["transfer_order.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: TransferOrderGeneratePickingTaskPage,
});
